import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

const CareOfDependentsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
              <Segment raised className={styles.highlightsItemWhiteBG} >   
                    <p className={styles.learnMoreAccordionText} > <br/>
                        In addition to setting up a Special Needs Trust, there are several other ways to plan for the care of the older adult's dependents. Setting up a care plan while the older adult is healthy is very important. Including family members (specifically siblings of the disabled adult child) in this planning is essential in making sure that family members in addition to the older adult are aware of the specific care needs of the disabled person.  
                        <br/><br/>
                        Some older caregivers are reluctant to burden their other children or other family members with this. However, new caregivers face a steep learning curve to understand the disabled adult’s needs after the older adult is unable to communicate or has passed away. Having this information in writing can ensure care is not interrupted during this time. 
                        <br/><br/>
                    </p> 
              </Segment>  
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips on Planning for Care of Adult Children/Family Members with Special Needs </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}CareOfDependentsLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(CareOfDependentsLearnMore);
